if (!customElements.get('product-sizes')) {
  customElements.define(
    'product-sizes',
    class ProductSizes extends HTMLElement {
      constructor() {
        super();

        this.sizeGuides = JSON.parse(
          this.querySelector('[data-size-guides]').textContent
        );
        this.sizeGuides = this.sizeGuides.size_guides;

        this.findButton = this.querySelector('[type="submit"]');
        this.heightInput = this.querySelector('[name="height"]');
        this.measurementSelect = this.querySelector('[name="measurement"]');

        this.resultsContainer = this.querySelector('.product-sizes__results');
        this.resultSize = this.querySelector('.product-sizes__result-value');
        this.resultTypicalAge = this.querySelector(
          '.product-sizes__typical-age'
        );
        this.resultsCm = this.querySelector('.product-sizes__cm');
        this.resultsIn = this.querySelector('.product-sizes__in');

        if (this.findButton) {
          this.findButton.addEventListener(
            'click',
            this.onFindButtonClick.bind(this)
          );
        }

        console.log(this.sizeGuides);
      }

      onFindButtonClick(e) {
        e.preventDefault();

        var found = false;

        this.currentHeight = this.heightInput.value;
        this.currentMeasurement = this.measurementSelect.value;

        console.log(this.currentHeight);
        console.log(this.currentMeasurement);

        for (const key in this.sizeGuides) {
          const sizeGuide = this.sizeGuides[key];

          console.log(sizeGuide);

          const rangeMin =
            this.currentMeasurement == 'in' && sizeGuide.range_unit == 'cm'
              ? sizeGuide.range_min / 2.54
              : this.currentMeasurement == 'cm' && sizeGuide.range_unit == 'in'
              ? sizeGuide.range_min * 2.54
              : sizeGuide.range_min;
          const rangeMax =
            this.currentMeasurement == 'in' && sizeGuide.range_unit == 'cm'
              ? sizeGuide.range_max / 2.54
              : this.currentMeasurement == 'cm' && sizeGuide.range_unit == 'in'
              ? sizeGuide.range_max * 2.54
              : sizeGuide.range_max;

          console.log(rangeMin);
          console.log(rangeMax);

          if (
            rangeMin <= this.currentHeight &&
            rangeMax >= this.currentHeight
          ) {
            this.resultSize.textContent = sizeGuide.european_size;
            this.resultTypicalAge.textContent = sizeGuide.typical_age;
            this.resultsCm.textContent = this.currentMeasurement == 'in' ? (this.currentHeight * 2.54).toFixed(1) : this.currentHeight;
            this.resultsIn.textContent = this.currentMeasurement == 'in' ? this.currentHeight : (this.currentHeight / 2.54).toFixed(1);

            found = true;

            break;
          }
        }

        if (found) {
          this.resultsContainer.classList.add('active');
        }
        else {
          this.resultsContainer.classList.remove('active');
        }
      }
    }
  );
}
